import { render, staticRenderFns } from "./ValveManage.vue?vue&type=template&id=510ecbab&"
import script from "./ValveManage.vue?vue&type=script&lang=js&"
export * from "./ValveManage.vue?vue&type=script&lang=js&"
import style0 from "./ValveManage.vue?vue&type=style&index=0&id=510ecbab&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports